import { Virtuoso } from 'react-virtuoso';
import UserAvatar from '@/components/common/user-carousel/user-avatar';
import type { ForwardListItem } from '@/hooks/contacts/use-forward-list';
import cn from '@/utils/merge-class-names';

interface Props {
  sessions: ForwardListItem[];
  className?: string;
  onRemove: (session: ForwardListItem) => void;
}

export default function SessionCarousel({ sessions, className, onRemove }: Props) {
  return (
    <Virtuoso
      horizontalDirection
      className={cn('basis-16', className)}
      data={sessions}
      fixedItemHeight={64}
      itemContent={(_, item) => (
        <UserAvatar
          className='size-16 overflow-hidden px-1'
          key={item.key}
          avatarUrl={item.imageURL}
          label={item.name}
          defaultAvatar={item.type}
          onRemove={() => onRemove(item)}
        />
      )}
    />
  );
}
